<template>
  <div
    @click="handleClick"
    class="shop-list-icon"
  >
    <img src="../../../../assets/images/icon_lb.png" alt="" />
    <!-- <span>列表</span> -->
  </div>
</template>

<script>
export default {
  name: 'ShopListIcon',
  props: {
    handelShopListIconClick: {
      type: Function,
      default: () => {},
    },
  },
  methods: {
    handleClick() {
      this.handelShopListIconClick()
    },
  },
}
</script>
<style lang='scss' scoped>
.shop-list-icon {
  width: 1.06rem;
  height: 1.06rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 50%;

  img {
    width: 1.06rem;
    display: inline-block;
  }
  span {
    font-size: 0.24rem;
    color: #c41b1b;
  }
}
</style>
